// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__8S+8i","inner":"Sidebar_inner__DP7eE","logo":"Sidebar_logo__FAJ6o"};